<template>
  <div class="invite-friends">
    <div class="invite-scale">
    <div class="t_body">
      <div class="div_main">
        <div class="div_head">
          <img
            class="img_return"
            src="/static/images/inviteFriends/ic_return.png"
            alt=""
            @click="handelBack"
          />
          <p class="title_text">Invite Friends to Earn Coins</p>
        </div>
        <div class="div_center">
          <div class="uesr_info">
            <img
              v-if="userInfo.avatarUrl"
              :src="userInfo.avatarUrl"
              class="img_head"
              alt=""
            />
            <div class="text-border">
              <p v-if="userInfo.nickname" class="p_name style_text">{{ userInfo.nickname }}</p>
              <p v-if="hasUserId" class="p_id style_text">ID:{{ userInfo.userId }}</p>
            </div>
          </div>
          <p class="p_info style_text">A gift for you! Come play with me.</p>

          <div v-if="awardList.length" class="div_gift_info">
            <div v-for="(item, index) in awardList" :key="index" class="gift_item">
              <div class="div_gift">
                <img v-if="item.awardIcon" class="img_award" :src="item.awardIcon" alt="" />
              </div>
              <p class="style_text gift_text">{{ awardText(item) }}</p>
            </div>
          </div>

          <div
            v-if="hasUserId"
            class="div_room is-copy"
            @click="copyUserId"
          >
            <span>Invitation ID: {{ userInfo.userId }}</span>
            <svg class="copy_icon" viewBox="0 0 24 24" aria-hidden="true">
              <rect x="8" y="8" width="12" height="12" rx="2" fill="none" stroke="currentColor" stroke-width="2" />
              <path d="M16 8V6a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h2" fill="none" stroke="currentColor" stroke-width="2" />
            </svg>
          </div>
        </div>

        <div class="div_foot">
          <img class="img_logo" src="/static/images/inviteFriends/logo.png" alt="" />
          <div class="text_info">
            <p class="text1">Zomii</p>
            <p class="text2">Meet New Friends</p>
          </div>
          <div class="div_download" @click="download">Download</div>
        </div>
      </div>
    </div>
    </div>
  </div>
</template>

<script>
import { request, setAuth, getUrlParams, closePage } from '../../utils/https'

const VIEWPORT =
  'width=device-width, initial-scale=1.0, maximum-scale=1.0, minimum-scale=1.0, user-scalable=0'

export default {
  name: 'InviteFriends',
  data() {
    return {
      userInfo: {},
      awardList: [],
      prevViewport: null,
    }
  },
  computed: {
    hasUserId() {
      return this.userInfo.userId != null && this.userInfo.userId !== ''
    },
  },
  mounted() {
    this.prevViewport = this.applyViewport(VIEWPORT)
    const queryCode = this.$route && this.$route.query && this.$route.query.code
    const inviteCode = queryCode || getUrlParams().code
    setAuth(inviteCode)
    this.getUserInfo()
  },
  beforeDestroy() {
    if (this.prevViewport != null) this.applyViewport(this.prevViewport)
  },
  methods: {
    applyViewport(content) {
      let meta = document.querySelector('meta[name="viewport"]')
      const prev = meta ? meta.getAttribute('content') : null
      if (!meta) {
        meta = document.createElement('meta')
        meta.setAttribute('name', 'viewport')
        document.head.appendChild(meta)
      }
      meta.setAttribute('content', content)
      return prev
    },
    download() {
      window.location.href = 'https://play.google.com/store/apps/details?id=com.zmi.group.voice&pli=1'
    },
    copyUserId() {
      if (!this.hasUserId) return
      this.copyText(String(this.userInfo.userId))
    },
    copyText(text) {
      const copied = () => {
        this.$message({
          message: 'Copied',
          type: 'success',
          duration: 1500,
          customClass: 'invite-copy-toast',
        })
      }
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(text).then(copied).catch(() => {
          this.fallbackCopy(text) && copied()
        })
        return
      }
      if (this.fallbackCopy(text)) copied()
    },
    fallbackCopy(text) {
      const input = document.createElement('input')
      input.value = text
      input.setAttribute('readonly', 'readonly')
      input.style.position = 'fixed'
      input.style.left = '-9999px'
      document.body.appendChild(input)
      input.select()
      input.setSelectionRange(0, text.length)
      let ok = false
      try {
        ok = document.execCommand('copy')
      } catch (e) {
        ok = false
      }
      document.body.removeChild(input)
      return ok
    },
    awardText(item) {
      if (!item) return ''
      if (item.awardType == 7) return (item.awardNum != null ? item.awardNum + ' ' : '') + 'Diamonds'
      if (item.awardType == 8) return (item.awardNum != null ? item.awardNum + ' ' : '') + 'Gold'
      const name = item.awardName ? item.awardName + ' ' : ''
      const num = item.awardNum != null && item.awardNum !== '' ? item.awardNum + 'days' : ''
      return (name + num).trim()
    },
    getUserInfo() {
      request
        .get('/api/act/invite/inviter')
        .then((res) => {
          if (!res || res.code !== 0 || res.data == null || res.data === '') return
          const info = res.data
          this.userInfo = info
          this.awardList = (info.awardList || []).filter(function (item) {
            return item
          })
        })
        .catch(() => {})
    },
    handelBack() {
      closePage()
    },
  },
}
</script>

<style scoped>
.invite-friends,
.invite-friends * {
  box-sizing: border-box;
}

.invite-friends {
  min-height: 100vh;
  min-height: 100dvh;
  background-color: #2a0d52;
  touch-action: pan-x pan-y;
  display: flex;
  justify-content: center;
}

.invite-scale {
  width: 100%;
  max-width: 750px;
  min-height: 100vh;
  min-height: 100dvh;
  background: #2a0d52 url(/static/images/inviteFriends/bg_main.png) center top / cover no-repeat;
  --u: calc(min(100vw, 750px) / 375);
}

.invite-friends p {
  margin: 0;
}

.t_body {
  width: 100%;
  min-height: 100vh;
  min-height: 100dvh;
  display: flex;
  flex-direction: column;
}

.div_main {
  flex: 1;
  display: flex;
  flex-direction: column;
  padding-top: calc(12 * var(--u));
  padding-top: calc(12 * var(--u) + env(safe-area-inset-top));
  padding-bottom: calc(20 * var(--u) + env(safe-area-inset-bottom));
  margin-left: calc(16 * var(--u));
  margin-right: calc(16 * var(--u));
}

.div_head {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

.title_text {
  color: #ffffff;
  font-size: calc(17 * var(--u));
  font-weight: 600;
  text-align: center;
  margin: 0;
}

.img_return {
  width: calc(24 * var(--u));
  height: calc(24 * var(--u));
  flex-shrink: 0;
  position: absolute;
  left: 0;
}

.div_center {
  width: 100%;
  margin-top: calc(48 * var(--u));
  padding-bottom: calc(18 * var(--u));
  position: relative;
  overflow: hidden;
  border-radius: calc(16 * var(--u));
  background-color: #8d46d8;
  background-image: url(/static/images/inviteFriends/card_bg.png);
  background-repeat: no-repeat;
  background-position: center top;
  background-size: 100% auto;
}

.style_text {
  font-weight: 700;
  color: #ffffff;
  text-align: left;
  font-size: calc(16 * var(--u));
}

.uesr_info {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding-top: calc(18 * var(--u));
  padding-left: calc(18 * var(--u));
}

.img_head {
  margin-right: calc(12 * var(--u));
  width: calc(64 * var(--u));
  height: calc(64 * var(--u));
  background-color: rgba(255, 255, 255, 0.2);
  border-radius: 50%;
  object-fit: cover;
}

.text-border {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.p_name {
  font-size: calc(18 * var(--u));
  font-weight: 700;
}

.p_id {
  margin-top: calc(4 * var(--u));
  font-size: calc(13 * var(--u));
  font-weight: 500;
  color: rgba(255, 255, 255, 0.92);
}

.p_info {
  width: 100%;
  margin-top: calc(16 * var(--u));
  font-size: calc(16 * var(--u));
  font-weight: 600;
  line-height: 1.35;
  padding-left: calc(18 * var(--u));
  padding-right: calc(18 * var(--u));
  white-space: nowrap;
}

.div_gift_info {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: flex-start;
  margin-top: calc(16 * var(--u));
  margin-left: calc(8 * var(--u));
  margin-right: calc(8 * var(--u));
}

.gift_item {
  width: 50%;
  padding: 0 calc(8 * var(--u));
  margin-bottom: calc(8 * var(--u));
  text-align: center;
}

.div_gift {
  width: calc(104 * var(--u));
  height: calc(104 * var(--u));
  background: rgba(36, 12, 72, 0.45);
  border-radius: calc(12 * var(--u));
  text-align: center;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
}

.gift_text {
  margin-top: calc(10 * var(--u));
  text-align: center;
  font-size: calc(13 * var(--u));
  font-weight: 500;
}

.img_award {
  width: calc(84 * var(--u));
  height: calc(84 * var(--u));
  object-fit: contain;
}

.div_join {
  font-weight: 700;
  margin: calc(22 * var(--u)) auto 0;
  text-align: center;
  width: calc(248 * var(--u));
  height: calc(44 * var(--u));
  font-size: calc(16 * var(--u));
  line-height: calc(44 * var(--u));
  color: #ffffff;
  background: url(/static/images/inviteFriends/ic_join.png) 0 0 / 100% 100% no-repeat;
}

.div_room {
  font-weight: 600;
  margin: calc(14 * var(--u)) auto 0;
  text-align: center;
  font-size: calc(15 * var(--u));
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
}

.div_room.is-copy {
  cursor: pointer;
  user-select: none;
}

.copy_icon {
  width: calc(14 * var(--u));
  height: calc(14 * var(--u));
  margin-left: calc(6 * var(--u));
  flex-shrink: 0;
}

.div_foot {
  margin-top: auto;
  padding-top: calc(24 * var(--u));
  display: flex;
  align-items: center;
}

.img_logo {
  width: calc(52 * var(--u));
  height: calc(52 * var(--u));
  border-radius: calc(12 * var(--u));
  object-fit: cover;
  flex-shrink: 0;
}

.text_info {
  color: #ffffff;
  margin-left: calc(8 * var(--u));
  flex: 1;
  min-width: 0;
}

.text1 {
  font-size: calc(16 * var(--u));
  font-weight: 700;
  text-shadow: 0 calc(1 * var(--u)) calc(4 * var(--u)) rgba(30, 0, 60, 0.55);
}

.text2 {
  margin-top: calc(2 * var(--u));
  font-size: calc(13 * var(--u));
  font-weight: 500;
  text-shadow: 0 calc(1 * var(--u)) calc(4 * var(--u)) rgba(30, 0, 60, 0.55);
}

.div_download {
  font-weight: 700;
  margin-left: calc(8 * var(--u));
  text-align: center;
  flex-shrink: 0;
  width: calc(96 * var(--u));
  height: calc(36 * var(--u));
  font-size: calc(14 * var(--u));
  line-height: calc(36 * var(--u));
  color: #ffffff;
  background: url(/static/images/inviteFriends/ic_download.png) 0 0 / 100% 100% no-repeat;
}
</style>
